import { RootState } from 'editor/src/store/index';

const getPersonalizationStudioBannerData = (state: RootState) => state.editor.personalizationStudioBannerData;

export default getPersonalizationStudioBannerData;
